import React, { useState, FC, useContext, ReactNode } from 'react'
import { Themes, applyTheme, getThemeByEnum } from './utils'
import { ThemeI } from './themes'

type ThemesProviderProps = { children: ReactNode }

export const ThemesProvider: FC<React.PropsWithChildren<ThemesProviderProps>> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(Themes.Default)
  const theme = getThemeByEnum(currentTheme)

  const _selectTheme = (theme: Themes) => {
    applyTheme(theme)
    setCurrentTheme(theme)
  }

  const selectDefaultTheme = () => _selectTheme(Themes.Default)
  const selectSiq2Theme = () => _selectTheme(Themes.Siq2)

  const contextValue = {
    currentTheme: {
      name: currentTheme,
      theme,
    },
    selectDefaultTheme,
    selectSiq2Theme,
  }

  return <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>
}

interface IThemeContext {
  currentTheme: {
    name: Themes
    theme: ThemeI
  }
  selectDefaultTheme: () => void
  selectSiq2Theme: () => void
}

const initContext: IThemeContext = {
  currentTheme: {
    name: Themes.Default,
    theme: {
      colors: {},
      fonts: { sizes: {}, fontFamilies: {}, colors: {} },
      components: {},
    },
  },
  selectDefaultTheme: () => {},
  selectSiq2Theme: () => {},
}

const ThemeContext = React.createContext<IThemeContext>(initContext)

export const useThemes = () => {
  return useContext(ThemeContext)
}
